import { Container } from '@pixi/display';
import { Sprite } from '@pixi/sprite';
import { Ticker } from '@pixi/ticker';

import { Shared } from '../App';

export class Shine extends Container
{
    private baseScale = 1;
    private sprite1:Sprite;
    private sprite2:Sprite;

    constructor(baseScale = 1)
    {
        super();
        this.baseScale = baseScale;

        this.sprite1 = new Sprite(Shared.assets.getTexture('currency-shine'));
        this.sprite1.anchor.set(0.5);
        this.sprite1.scale.set(this.baseScale);
        this.addChild(this.sprite1);

        this.sprite2 = new Sprite(Shared.assets.getTexture('currency-shine'));
        this.sprite2.anchor.set(0.5);
        this.sprite2.scale.set(this.baseScale);
        this.addChild(this.sprite2);

        this.interactive = false;
        this.interactiveChildren = false;
    }

    public updateTransform(): void
    {
        super.updateTransform();
        const mod = Math.sin(Ticker.system.lastTime * 0.005) * this.baseScale * 0.5;
        const base =  this.baseScale * 0.5;

        this.sprite1.scale.set(base + mod);
        this.sprite1.rotation += 0.1;

        this.sprite2.scale.set((base - mod) * 0.75);
        this.sprite2.rotation += 0.07;
    }
}
